import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";
import {Link} from "react-router-dom";
import CallToAction from "../components/CallToAction";
import Card from '@mui/joy/Card';
import Button from '@mui/joy/Button';
import { Grid } from "@mui/joy";
import './styles/home.css';

import nhv from '../assets/nhv-outside.png'
import WhatWeBelieve from '../assets/WhatWeBelieve.jpg'
import WhoWeAre from '../assets/WhoWeAre.jpg'
import HowToConnect from '../assets/HowToConnect.jpg'
import ContactModal from "../components/ContactModal";


function Home() {
    return (
            <Box className='video'>
                <Box className='header' sx={{marginBottom: 0}} justifyContent="center" textAlign="center">
                        <Grid container direction='column'>
                            <Box className='image-header' sx={{backgroundImage: `url(${nhv})`}}>
                            <Grid item>
                                <Box>
                                    <Stack direction='column' spacing={{md:2, xs: 1}} sx={{padding: {md: 10, xs: 6}}}>
                                        <Typography className="centered" textColor="white" level='h1' fontSize={{lg:'2.2rem' , xs: '1.0rem'}}>
                                            Welcome to New Horizon Vineyard
                                        </Typography>
                                        <Typography className="centered" textColor="white" level='h1' fontSize={{lg: '5rem', xs: '1.9rem'}}>
                                            We're Glad You're Here
                                        </Typography>
                                        <Typography className="centered" textColor="white" level='h3' fontSize={{lg: '1.8rem', xs: '.8rem'}}>
                                            Join us this Sunday
                                        </Typography>
                                        <Typography className="centered" textColor="white" level='h3' fontSize={{lg: '1.8rem', xs: '.8rem'}}>
                                            10:45 AM
                                        </Typography>
                                        <Box>
                                            <CallToAction />
                                        </Box>
                                    </Stack>
                                </Box>
                            </Grid>
                            </Box>
                        </Grid>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <Box sx={{width: '100%', backgroundColor: 'white'}}>
                            <Box className='cardContainer' alignItems='center' textAlign='center' sx={{marginBottom: 6, backgroundColor: 'white'}}>
                                <Box>
                                    <Typography textAlign={"center"} textColor="#006494" level="h1" sx={{marginTop: 6}}>
                                        Ways to Get Involved
                                    </Typography>
                                    <Typography level="body-lg" sx={{marginTop: 2, paddingRight: '20%', paddingLeft: '20%'}}>
                                        Whether you're new to our community or looking to deepen your involvement, there are many ways to get connected at New Horzion Vineyard. 
                                        From volunteer opportunities and small groups to outreach programs and special events, we invite you to explore how your time, talents, and passions can make a difference. 
                                        Join us as we grow in faith together and serve others with purpose and love.
                                    </Typography>
                                </Box>
                                <Grid container  spacing={12} sx={{justifyContent: "center", marginTop: 4}}>
                                    <Grid>
                                        <Card className="card" sx={{
                                            height: 350,
                                            width: 320,
                                            backgroundImage: `url(${WhoWeAre})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            border: 'solid 1px #000000'
                                        }}>
                                            <Typography className='cardText' textAlign={"center"} textColor="white" level="title-lg"
                                                        sx={{marginTop: 22}}>Who We Are</Typography>
                                            <Typography className='cardText' textColor="white" level="body-md">
                                                Get to know the people serving our church and shaping our vision.
                                            </Typography>
                                            <Link to='/leaders'>
                                                <Button sx={{backgroundColor: '#006494'}} className="cardButton" href='/leaders' variant="solid">
                                                    <a className='cardButton-link' href="/leaders">Learn More!</a>
                                                </Button>
                                            </Link>
                                        </Card>
                                    </Grid>
                                    <Grid>
                                        <Card className="card" sx={{
                                            height: 350,
                                            width: 320,
                                            backgroundImage: `url(${WhatWeBelieve})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            border: 'solid 1px #000000'
                                        }}>
                                            <Typography className='cardText' textAlign={"center"} textColor="white" level="title-lg"
                                                        sx={{marginTop: 22}}>What We Believe</Typography>
                                            <Typography className='cardText' textColor="white" level="body-md">
                                                Explore the core beliefs that shape our faith and guide our community.
                                            </Typography>
                                            <Link to='/beliefs'>
                                                <Button sx={{backgroundColor: '#006494'}} className="cardButton" href='/beliefs' variant="solid">
                                                    <a className='cardButton-link' href="/beliefs">Learn More!</a>
                                                </Button>
                                            </Link>
                                        </Card>
                                    </Grid>
                                    <Grid>
                                        <Card className="card" sx={{
                                            height: 350,
                                            width: 320,
                                            backgroundImage: `url(${HowToConnect})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            border: 'solid 1px #000000'
                                        }}>
                                            <Typography className='cardText' textAlign={"center"} textColor="white" level="title-lg"
                                                        sx={{marginTop: 22}}>How To Connect</Typography>
                                            <Typography className='cardText' textColor="white" level="body-md">
                                                Whether you're new or looking to go deeper, there's a place for you here.
                                            </Typography>
                                            <Link to='/ministries'>
                                                <Button sx={{backgroundColor: '#006494'}} className="cardButton" href='/ministries' variant="solid">
                                                    <a className='cardButton-link' href="/ministries">Learn More!</a>
                                                </Button>
                                            </Link>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Box>
                    </Box>
                </Box>
                <Box textAlign='center' sx={{backgroundColor: '#006494', marginTop: 2, height: '30vh'}}>
                    <Box sx={{padding: "3%"}}>
                        <Stack direction='column' spacing={2} alignItems='center'>
                            <Typography sx={{ color: '#fff'}} level="h1">Faithful Fellowship</Typography>
                            <Typography sx={{ color: '#fff'}}>Discover why the Vineyard could be the place you call HOME.</Typography>
                            <ContactModal linkClass='connectButton' text='Connect'/>
                        </Stack>
                    </Box>
                </Box>
        </Box>
        
    );
}

export default Home;
